import { FC, useCallback, useEffect, useMemo, useState } from 'react'
import { Box, Button, Flex, VStack, Text, Image } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { CheckboxConfirm } from './checkbox-confirm'
import { cardImageMap } from '../../state/interfaces'

export interface CheckboxConfirmOnlyNewsletterProps {
  onChange?: (newValues: string[]) => void
  onConfirm?: (values: string[]) => void
  grandImage?: string
}

export const CheckboxesConfirmOnlyNewsLetter: FC<CheckboxConfirmOnlyNewsletterProps> = ({ onConfirm, grandImage }) => {
  const { t } = useTranslation()

  const [selectedChoices, setSelectedChoices] = useState<string[]>([])
  const [isConfirmedPrice, setIsConfirmedPrice] = useState(false)

  const handleCheckboxChange = (value: string, checked: boolean) => {
    if (checked) {
      setSelectedChoices((prevSelected) => [...prevSelected, value])
    } else {
      setSelectedChoices((prevSelected) => prevSelected.filter((val) => val !== value))
    }
  }
  const image = useMemo(() => (grandImage ? cardImageMap[grandImage] : ''), [grandImage])

  useEffect(() => {
    setIsConfirmedPrice(selectedChoices.includes('confirm-newsletter'))
  }, [selectedChoices])

  const confirmChoices = useCallback(() => {
    onConfirm && onConfirm(selectedChoices)
  }, [onConfirm, selectedChoices])

  return (
    <VStack>
      <Flex direction="column" marginY={5} maxW={{ md: 600 }}>
        <label>
          <Box border="1px solid lightgrey" borderRadius={6}>
            <Box display="flex" width="100%" paddingX={6} paddingY={2}>
              <Flex alignItems="center" minW={{ base: 120, md: 200 }}>
                <Flex border="1px solid lightgrey" alignItems="center" mt={1} minW={'18px'} zIndex={2}>
                  <CheckboxConfirm value="confirm-newsletter" onChange={handleCheckboxChange} />
                </Flex>
                <Text ml={4} whiteSpace="normal" cursor="pointer" fontSize={{ base: '14', md: '16' }}>
                  <strong>
                    {t('mandatory-confirmation-title')}{' '}
                    <span style={{ color: 'red', textTransform: 'uppercase' }}>*</span>
                  </strong>
                  <br />
                  {t('mandatory-confirmation-visitor-text')}
                </Text>
              </Flex>
            </Box>
          </Box>
        </label>
      </Flex>
      <Button
        onClick={confirmChoices}
        disabled={!isConfirmedPrice}
        variant="solid"
        color="white"
        backgroundColor="green.600"
        fontSize="xs"
        fontWeight="bold"
        borderWidth="2px"
        borderColor="green.600"
        px={16}
        py={6}
        _focus={{
          borderColor: 'brand',
          boxShadow: '0 0 0 2px #5bce4c',
        }}
      >
        {t('common_continue')}
      </Button>
      {image && <Image src={image} alt="image" width={['60%', '45%']} />}
    </VStack>
  )
}
